import { 
  Apple, 
  Milk, 
  Croissant, 
  Fish, 
  Coffee, 
  Package, 
  Snowflake, 
  Sparkles, 
  Pill, 
  Cookie,
  Utensils,
  type LucideIcon
} from 'lucide-react';

export interface Category {
  name: string;
  icon: LucideIcon;
  color: string;
}

export const CATEGORIES: Record<string, Category> = {
  'Obst & Gemüse': {
    name: 'Obst & Gemüse',
    icon: Apple,
    color: '#10b981'
  },
  'Milchprodukte': {
    name: 'Milchprodukte',
    icon: Milk,
    color: '#3b82f6'
  },
  'Backwaren': {
    name: 'Backwaren',
    icon: Croissant,
    color: '#f59e0b'
  },
  'Fleisch & Fisch': {
    name: 'Fleisch & Fisch',
    icon: Fish,
    color: '#ef4444'
  },
  'Getränke': {
    name: 'Getränke',
    icon: Coffee,
    color: '#8b5cf6'
  },
  'Konserven': {
    name: 'Konserven',
    icon: Package,
    color: '#6b7280'
  },
  'Tiefkühl': {
    name: 'Tiefkühl',
    icon: Snowflake,
    color: '#06b6d4'
  },
  'Haushalt': {
    name: 'Haushalt',
    icon: Sparkles,
    color: '#14b8a6'
  },
  'Drogerie': {
    name: 'Drogerie',
    icon: Pill,
    color: '#ec4899'
  },
  'Süßigkeiten': {
    name: 'Süßigkeiten',
    icon: Cookie,
    color: '#a855f7'
  },
  'Gewürze & Soßen': {
    name: 'Gewürze & Soßen',
    icon: Utensils,
    color: '#f97316'
  }
};

export function getCategory(categoryName?: string | null): Category | null {
  if (!categoryName) return null;
  return CATEGORIES[categoryName] || null;
}

export function getCategoryIcon(categoryName?: string | null) {
  const category = getCategory(categoryName);
  return category?.icon || null;
}

export function getCategoryColor(categoryName?: string | null): string {
  const category = getCategory(categoryName);
  return category?.color || '#6b7280';
}

export function getAllCategories(): [string, Category][] {
  return Object.entries(CATEGORIES);
}
